// Small shared pieces for the partner hub and the live table.
import React from "react";

const PALETTE = ["#3b5bdb", "#c2410c", "#7c3aed", "#0f766e", "#be185d", "#1d4ed8", "#a16207", "#047857"];
function colourFor(name) {
  let h = 0;
  for (const ch of String(name || "")) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
}
export function initials(name) {
  const p = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!p.length) return "?";
  return (p[0][0] + (p.length > 1 ? p[p.length - 1][0] : "")).toUpperCase();
}

export function Avatar({ name, online, size = "lg", overlap = false }) {
  return (
    <span className={`pth-av pth-av--${size} ${overlap ? "pth-av--overlap" : ""}`} style={{ background: colourFor(name) }} aria-hidden="true">
      {initials(name)}
      {online !== undefined && <i className={`pth-dot ${online ? "is-on" : ""}`} />}
    </span>
  );
}

export function timeAgo(ms) {
  const s = Math.max(0, (Date.now() - ms) / 1000);
  if (s < 90) return "just now";
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  const d = Math.round(s / 86400);
  return d === 1 ? "yesterday" : `${d} days ago`;
}

export const SYM = { S: "♠", H: "♥", D: "♦", C: "♣", N: "NT" };
export const SEAT_NAME = { N: "North", E: "East", S: "South", W: "West" };
export const rankText = (r) => (r === "T" ? "10" : r);
export const suitCls = (s) => `pth-s-${s}`;

export function Strain({ s }) {
  return <span className={suitCls(s)}>{SYM[s]}</span>;
}

export function CallText({ call }) {
  if (!call) return null;
  if (call.kind === "pass") return <span className="pth-call pth-call--pass">Pass</span>;
  if (call.kind === "double") return <span className="pth-call pth-call--x">X</span>;
  if (call.kind === "redouble") return <span className="pth-call pth-call--x">XX</span>;
  return <span className="pth-call">{call.level}<Strain s={call.strain} /></span>;
}

export function ContractText({ contract, declarer }) {
  if (!contract) return <span>Passed out</span>;
  const dbl = contract.doubled === 2 ? " XX" : contract.doubled === 1 ? " X" : "";
  return (
    <span className="pth-contract">
      {contract.level}<Strain s={contract.strain} />{dbl}
      {declarer && <span className="pth-contractBy"> {SEAT_NAME[declarer]}</span>}
    </span>
  );
}

export const signed = (n) => (n > 0 ? `+${n}` : `${n}`);
